import { Flex, FlexProps, Dot, Text, Tooltip } from '@bitrise/bitkit';
import { FirestoreDetection } from '@trace/types';
import { firestore } from 'firebase/app';
import { DateTime } from 'luxon';
import React, { useContext, FunctionComponent } from 'react';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { ACTIVE_THRESHOLD_DAYS_INACTIVE, ACTIVE_THRESHOLD_DAYS_QUIET } from '../../constants/SDK';
import { AuthContextTrace } from '../Authenticate/AuthenticateTrace';

const getLastSeenState = (days: number) => {
  if (days < ACTIVE_THRESHOLD_DAYS_INACTIVE) return 0;
  if (days < ACTIVE_THRESHOLD_DAYS_QUIET) return 1;
  return 2;
};

const getLastSeenRelativeTime = (lastSeenDateTime: DateTime) => {
  const duration = lastSeenDateTime.diffNow('seconds').seconds;

  if (duration > -60) {
    return 'Now';
  }

  return lastSeenDateTime.toRelative();
};

const SDKIndicator: FunctionComponent<FlexProps> = (props) => {
  const {
    data: { appId },
  } = useContext(AuthContextTrace);
  const [detection] = useDocumentData<FirestoreDetection>(firestore().doc(`/detections/${appId}`));
  const lastSeenDateTime =
    detection && detection.lastSeen ? DateTime.fromJSDate(detection.lastSeen.toDate()) : null;
  const lastSeenState = lastSeenDateTime
    ? getLastSeenState(lastSeenDateTime.diffNow('days').days)
    : 0;

  return (
    <Flex {...props} alignChildrenVertical="middle" direction="horizontal" gap="x2">
      <Flex>
        <Dot
          backgroundColor={
            (lastSeenState === 0 && 'red-3') || (lastSeenState === 1 && 'yellow-3') || 'green-3'
          }
          size="10px"
        />
      </Flex>

      <Flex grow>
        <Text config="8">SDK Activity</Text>
      </Flex>

      {lastSeenDateTime ? (
        <Tooltip title={lastSeenDateTime.toFormat('ff')}>
          {({ ref, ...rest }) => (
            <Flex {...rest} innerRef={ref}>
              <Text config="8">{getLastSeenRelativeTime(lastSeenDateTime)}</Text>
            </Flex>
          )}
        </Tooltip>
      ) : (
        <Flex>
          <Text config="8">Detecting...</Text>
        </Flex>
      )}
    </Flex>
  );
};

export default SDKIndicator;
